import React from "react";
import PropTypes from "prop-types";

const Group = ({ title, children }) => (
  <div className="mb-4">
    {title ? <h1 className="side-nav__title">{title}</h1> : null}
    {children}
  </div>
);

Group.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default Group;
